/**
 * Global :root variables doesn't work
 * TODO: All states and colors need to be defined, such as: focus, disabled, etc.
 */

import { StylesConfig } from 'react-select';

const reactSelectStyles: StylesConfig = {
    container: (defaultStyles) => ({
        ...defaultStyles,
        width: '100%',
        height: '36px',
    }),
    control: (defaultStyles, state) => ({
        ...defaultStyles,
        fontSize: '13px',
        fontWeight: 400,
        width: '100%',
        height: '100%',
        minHeight: '36px',
        background: 'var(--secondary)',
        boxShadow: 'none',
        border: `1px solid ${state.isFocused ? '#e8e9ea' : 'var(--secondary)'}`,
        borderRadius: '8px',
        '&:hover': { outline: 'none', cursor: 'pointer' },
    }),
    indicatorsContainer: (defaultStyles) => ({
        ...defaultStyles,
        height: '36px',
    }),
    dropdownIndicator: (defaultStyles) => ({
        ...defaultStyles,
        padding: '0 8px 0 0',
        color: 'var(--gray2)',
        '&:hover': { color: 'var(--gray1)' },
    }),
    indicatorSeparator: (defaultStyles) => ({
        ...defaultStyles,
        display: 'none',
    }),
    option: (defaultStyles: any, state: any) => ({
        ...defaultStyles,
        color: state.isSelected ? 'var(--white)' : 'var(--gray)',
        background: state.isSelected ? 'var(--primary)' : 'var(--white)',
        fontSize: '13px',
        '&:hover': { cursor: 'pointer', background: !state.isSelected && 'var(--pale)' },
    }),
    groupHeading: (defaultStyles) => ({
        ...defaultStyles,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        background: 'var(--pale)',
        margin: 0,
        height: '30px',
        fontSize: '14px',
        textTransform: 'capitalize',
    }),
    menu: (defaultStyles) => ({
        ...defaultStyles,
        width: '100%',
        height: 'auto',
        background: 'var(--white)',
        borderRadius: '8px',
        overflow: 'hidden',
    }),
    menuList: (defaultStyles) => ({
        ...defaultStyles,
        maxHeight: '150px',
        margin: 0,
        padding: 0,
        textAlign: 'left',
    }),
    group: (defaultStyles) => ({
        ...defaultStyles,
        margin: 0,
        padding: 0,
    }),
    placeholder: (defaultStyles) => ({
        ...defaultStyles,
        color: 'var(--gray2)',
        maxWidth: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    }),
    valueContainer: (defaultStyles) => ({
        ...defaultStyles,
        padding: '2px 12px',
    }),
};

export default reactSelectStyles;
